<template>
  <div class="NavigationDrawer">
    <NavigationLinksTree
      v-for="(item, index) in navigationLinks"
      :key="`item-${index}`"
      :node="item"
    />

    <div class="NavigationDrawer__social">
      <a
        href="#"
        class="NavigationDrawer__socialIcon NavigationDrawer__socialIcon--facebook"
      >
        <i
          class="fab fa-facebook-square"
          aria-hidden="true"
        />
      </a>
      <a
        href="#"
        class="NavigationDrawer__socialIcon NavigationDrawer__socialIcon--twitter"
      >
        <i
          class="fab fa-twitter-square"
          aria-hidden="true"
        />
      </a>
    </div>
  </div>
</template>

<script>
import NavigationLinksTree from '@/components/navigation/LinksTree.vue';

export default {
  name: 'NavigationDrawer',
  components: {
    NavigationLinksTree,
  },
  computed: {
    navigationLinks() {
      return this.$store.state.content.navigationLinks;
    },
  },
};
</script>

<style scoped lang="scss">
.NavigationLinksTree {
  margin-bottom: 7px;

  &:last-child {
    margin-bottom: 0;
  }
}
.NavigationDrawer__social {
  margin-top: 20px;
}
.NavigationDrawer__socialIcon {
  font-size: 32px;
  margin-right: 15px;
}
.NavigationDrawer__socialIcon--facebook {
  color: #3B5998;
}
.NavigationDrawer__socialIcon--twitter {
  color: #1DA1F2;
}
</style>
